import React, { useContext } from "react";
import Sidenavigation from "../layouts/Sidenavigation";
import Topnavigation from "../layouts/Topnavigation";
import Breadcrumb from "../sections/Paymentcontent/Breadcrumb";
import Content from "../sections/Paymentcontent/Content";
import Quickbar from "../layouts/Quickbar";
import AuthContext from "../../context/auth-context";

export const Payment = (props) => {
  const ctx = useContext(AuthContext);

  return (
    <div
      className={
        ctx.darkMode
          ? "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar ms-dark-theme"
          : "ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar"
      }
    >
      <Sidenavigation />
      <main className="body-content">
        <Topnavigation />
        <div className="ms-content-wrapper">
          <div className="row">
            <div className="col-md-12">
              <Breadcrumb />
              <Content />
            </div>
          </div>
        </div>
      </main>
      <Quickbar />
    </div>
  );
};

export default Payment;
